import { defineComponent, ref } from 'vue';
import styles from './index.module.scss';
import {
  FormRules,
  NButton,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NModal,
  NRadioButton,
  NRadioGroup,
  NRate,
  NUpload,
  UploadFileInfo,
  useMessage,
} from 'naive-ui';
import Typography from '@/components/TextFormat/FormatElements/Typography';
import { SettledFileInfo } from 'naive-ui/es/upload/src/interface';
import { useStore } from 'vuex';
import webConfig from '@dts/shared/src/utils/httpUrlConfig';
import TLForm from '@/components/CPForm/index.vue';
import { PRIMARY_COLOR } from '@dts/shared/src/config/color';
const props = {
  show: {
    type: Boolean,
    require: true,
  },
};

const channelList = [
  {
    label: 'Homepage',
    value: 'Homepage',
  },
  {
    label: 'Services',
    value: 'Services',
  },
  {
    label: 'Data & AI Use Case',
    value: 'Data & AI Use Case',
  },
  {
    label: 'Training Center',
    value: 'Training Center',
  },
  {
    label: 'Community',
    value: 'Community',
  },
  {
    label: 'Others',
    value: 'Others',
  },
];

const Feedback = defineComponent({
  emits: ['update:show'],
  setup: (props, { attrs, emit }) => {
    const store = useStore();
    const message = useMessage();

    const token = store.state.user.token;

    const formModel = ref<defs.dtsServer.DtsFeedbackParam>({
      score: undefined,
      description: '',
      channel: '',
      fileMappingObjectList: [],
    });
    const form = ref<any>({
      role: 1,
      type: 2,
    });
    const fileMap = ref<any>({});
    const formRef = ref();
    const rules = ref<FormRules>({
      score: {
        type: 'number',
        required: true,
        message: 'Please select satisfaction!',
        trigger: ['input', 'blur'],
      },
      description: {
        required: true,
        message: 'Please enter description!',
        trigger: ['input', 'blur'],
      },
      channel: {
        required: true,
        message: 'Please select channel!',
        trigger: ['change'],
      },
    });

    const handleClose = () => {
      formModel.value = {
        score: undefined,
        description: '',
        channel: '',
        fileMappingObjectList: [],
      };
      emit('update:show', false);
    };
    const changeFileList = ({ fileList }: { fileList: SettledFileInfo[] }) => {
      formModel.value.fileMappingObjectList = fileList
        .filter((item) => item.status === 'finished')
        .map((item) => {
          return fileMap.value[item.id];
        });
    };

    const submit = () => {
      formRef.value?.validate((err: any) => {
        if (!err) {
          $dts.dtsFeedback.create.request({}, { ...(formModel.value || {}) }).then((res) => {
            message.success('Thanks for your feedback!');
            handleClose();
          });
        }
      });
    };
    const emitImg = (val: any) => {
      formModel.value.fileMappingObjectList = val;
    };
    const finishFile = ({ file, event }: { file: UploadFileInfo; event?: ProgressEvent }) => {
      const fetchRes = event?.currentTarget as XMLHttpRequest;
      const jsonResponse = JSON.parse(fetchRes.response || '');
      if (jsonResponse.status === '500' || jsonResponse.status === '521') {
        return;
      }
      file.name = 'Template.xlsx';
      fileMap.value[file.id] = jsonResponse.data[0];

      return file;
    };

    return () => (
      <>
        <NModal show={props.show} class={styles.Feedback}>
          <NCard
            style={{ width: '7.51rem' }}
            v-slots={{
              header: () => <Typography.H3>Feedback</Typography.H3>,
              default: () => (
                <>
                  <Typography.Text size={20}>
                    Thank you for taking the time to give us your valuable feedback.
                  </Typography.Text>
                  <NForm
                    ref={formRef}
                    model={formModel.value}
                    rules={rules.value}
                    size="large"
                    style={{ marginTop: '.4rem' }}
                  >
                    <NFormItem
                      v-slots={{
                        label: () => (
                          <Typography.Text size={20} weight={400}>
                            Your satisfaction
                          </Typography.Text>
                        ),
                        default: () => (
                          <NRate
                            style={{ marginTop: '.16rem' }}
                            size="large"
                            color="#3309CD"
                            allow-half
                            v-model:value={formModel.value.score}
                          />
                        ),
                      }}
                      path="score"
                    />
                    <NFormItem
                      v-slots={{
                        label: () => (
                          <Typography.Text size={20} weight={400}>
                            Channel
                          </Typography.Text>
                        ),
                        default: () => (
                          <div class={styles.radioGroup} style={{ marginTop: '.16rem' }}>
                            {channelList.map((ch) => (
                              <NRadioGroup key={ch.value} v-model:value={formModel.value.channel}>
                                <NRadioButton value={ch.value}>
                                  <Typography.Fig class={styles.text}>{ch.label}</Typography.Fig>
                                </NRadioButton>
                              </NRadioGroup>
                            ))}
                          </div>
                        ),
                      }}
                      path="channel"
                    />
                    <NFormItem
                      v-slots={{
                        label: () => (
                          <Typography.Text size={20} weight={400}>
                            Description
                          </Typography.Text>
                        ),
                        default: () => (
                          <NInput
                            style={{ marginTop: '.16rem' }}
                            v-model:value={formModel.value.description}
                            type="textarea"
                            class="input_tip"
                            show-count
                            autosize={{ minRows: 6 }}
                            maxlength={500}
                            placeholder="Looking forward to your voice. Requirement/Question/Suggestion."
                          />
                        ),
                      }}
                      path="description"
                    />
                    <NFormItem
                      v-slots={{
                        label: () => (
                          <Typography.Text size={16} weight={300} color="#666">
                            Please upload supporting pictures (JPG, JPEG, PNG)
                          </Typography.Text>
                        ),
                        default: () => (
                          // <NUpload
                          //   action={webConfig.apiUrl + '/feedback/file/upload'}
                          //   style={{ marginTop: '.16rem' }}
                          //   list-type="image-card"
                          //   multiple={false}
                          //   accept=".png, .jpg, .jpeg"
                          //   name="files"
                          //   onChange={changeFileList}
                          //   headers={{ 'X-Token': token }}
                          //   max={3}
                          //   onFinish={finishFile}
                          // />

                          <TLForm v-modal="form" onEmitImg={emitImg} />
                        ),
                      }}
                    />
                  </NForm>
                </>
              ),
              footer: () => (
                <div class={styles.footer}>
                  <NButton
                    class={styles.btn}
                    color={PRIMARY_COLOR}
                    type="info"
                    onClick={() => submit()}
                  >
                    Submit
                  </NButton>
                  <NButton class={styles.btn} onClick={handleClose}>
                    Cancel
                  </NButton>
                </div>
              ),
            }}
            closable
            onClose={handleClose}
          />
        </NModal>
      </>
    );
  },
  props,
});
export default Feedback;
